import {
  computed,
  ref,
} from 'vue';

import { TDomainError } from '@/types';
import { useUserStore } from '@/stores/user';
import { useTenantsStore } from '@/stores/tenants';
import { useAppStore } from '@/stores/app';

export const useAppGlobalEntities = () => {
  const isGlobalEntitiesLoading = ref(false);

  /** Если oneTimePassword === true, то fetchTenant - отдаст 403, т.к. не будет доступа к tenants
    * чтобы не делать ненужного запроса и не ловить ошибку - добавим проверку на oneTimePassword(OTP) */
  const isUserLoggedInByOTP = computed(() => useUserStore().user?.lockedSince && useUserStore().user?.oneTimePassword);

  const fetchGlobalEntities = () => {
    const appStore = useAppStore();
    const userStore = useUserStore();
    const tenantsStore = useTenantsStore();

    if (userStore.user && !isUserLoggedInByOTP.value) {
      return tenantsStore.loadTenants().catch((error: TDomainError) => {
        appStore.$reset();
        throw error;
      });
    }

    if (!userStore.user) {
      return userStore.loadUser(false)
        .then(() => {
          if (!isUserLoggedInByOTP.value) {
            return tenantsStore.loadTenants().catch((error: TDomainError) => {
              throw error;
            });
          }
          return Promise.resolve();
        })
        .catch((error: TDomainError) => {
          appStore.$reset();
          throw error;
        });
    }

    return Promise.resolve();
  };

  return {
    isGlobalEntitiesLoading,

    fetchGlobalEntities,
  };
};
